import React, { useState } from 'react';
import ODSSelectScreen from '../../screen/ODSSelect';
import { sort } from 'fast-sort'
import { ods } from '../../core/utils/ods/indicadores';

const ODSSelectContainer = () => {
  const [state, setState] = useState({})


  const onChange = (code, value) => {
    setState(state => ({ ...state, [code]: value }))
  }

  const onSelectAll = (data) => {
    setState(state => ({ ...state, ...data }))
  }

  const data = sort(ods).asc(u => u.odsIndex)

  return <ODSSelectScreen values={state} onSelectAll={onSelectAll} onChange={onChange} ods={data} />;
}

export default ODSSelectContainer;